export function enableRecaptchaOnPermit() {
    const postButton = document.getElementById("send-button") as HTMLButtonElement;
    const form = document.getElementById("permit-form") as HTMLFormElement;

    if (!postButton) {
        console.error("No post button was found.");
        return;
    }

    if (!form) {
        console.error("No form was found.");
        return;
    }

    postButton.onclick = async (e) => {
        e.preventDefault();

        const grecaptcha = (window as any).grecaptcha;
        const PublicSiteKey = (window as any).permesso.recaptchaPublicSiteKey;

        const result = await grecaptcha.enterprise.execute(PublicSiteKey);

        const tokenInput = document.getElementById("BaseDocumentViewModel_RecaptchaToken") as HTMLInputElement;

        if (!tokenInput) {
            console.error("No token input was found.");
            return;
        }

        tokenInput.value = result;
        form.submit();
    };
}
